import { render, staticRenderFns } from "./CompareModel.vue?vue&type=template&id=5077e4e0&"
import script from "./CompareModel.vue?vue&type=script&lang=js&"
export * from "./CompareModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports